import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { env, python } from 'src/environments/environments';
import { ApiResponse, ImagesData } from '../interfaces/images/image.data.interface';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  private readonly url = `${python.url_base}`;


  constructor(
    private http: HttpClient,
  ) { }


  getImages(): Observable<{ success: boolean, message: string, data?: ImagesData[] }> {
    const headers = { 'Content-Type': 'application/json' };
    const urlResource = `${this.url}/obtenerAssetsLan`; //`${this.url}/obtenerAssetsLanding`;

    return this.http.get<{ success: boolean, message: string, data?: ImagesData[] }>(urlResource, { headers }).pipe(
      switchMap(response => {
        if (response.success) {
          return of({ success: true, message: 'Las imagenes se obtuvieron satisfactoriamente', data: response.data });
        } else {
          return of({ success: false, message: response.message });
        }
      }),
      catchError(error => {
        console.error('Error en la llamada a la API:', error);
        return of({ success: false, message: error.message });
      })
    );
  }
}
